<template>
  <div>Edit People</div>
</template>

<script>
export default {};
</script>